import React from 'react';
import PropTypes from 'prop-types';
import { grey } from '@mui/material/colors';
import { Button, Container, Dialog, Typography } from '@mui/material';
import styles from './guidesQRImageDialogStyles';

GuidesQRImageDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function GuidesQRImageDialog({ onClose, open, urlImage }) {

  /* const handleDownloadPDFClick = () => {
    if(isLoading) { return; }
    setIsLoading(true);

    const link = document.createElement('a');
    link.href = urlPDF;
    link.setAttribute('target', '_blank');
    link.download = 'GuíaCódigoQR.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setIsLoading(false);
    onClose();
  } */

  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <Dialog onClose={handleDialogClose} open={open} PaperProps={{ style: { borderRadius: '16px' } }} >
      <Container style={{ padding: 30, display: 'flex', flexDirection: 'column', justifyContent: 'center' }} >
        <Typography component="div" variant="h5" style={{ textAlign: 'center', fontWeight: 'bold', color: grey[800], marginBottom: 5 }} >
          Código QR
        </Typography>

        <img src={urlImage} alt='QR Code' />

        <Container style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: 0, marginTop: 0, gap: 12 }}>
          <Button
            variant="standard"
            color="primary"
            onClick={() => {
              onClose();
            }}
            style={styles.cancelButton}
          >
            Cerrar
          </Button>
          {/* <Button variant="contained" onClick={() => { }}
            sx={activeButtonStyles}>
            {
              isLoading ? <CircularProgress size={24} style={{ color: 'white' }} /> : 'Descargar código QR'
            }
          </Button> */}
        </Container>
      </Container>
      
    </Dialog>
  );
}